import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function RichViewToggleButton({ active, hasIntegration }) {
  const navigate = useNavigate();

  // Don't render if no IoT integration is available (unless already in active/rich view)
  if (!hasIntegration && !active) {
    return null;
  }

  // Determine button text and style based on the "active" parameter
  const btnText = active ? 'Rich View Active' : 'Switch to Rich View';
  const btnClass = active ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary';

  function handleSwitchClick() {
    if (active) {
      navigate(`../`, { relative: 'path' });
    }else{
      navigate(`./advanced`, { relative: 'path' });
    }
  }

  return (
    <div className="row justify-content-end mb-3">
      <div className="col-12 d-flex justify-content-end">
        <button
          className={`${btnClass} d-flex align-items-center justify-content-center`}
          onClick={handleSwitchClick}
        >
          <i className="bi bi-globe2 me-1"></i>
          {btnText}
        </button>
      </div>
    </div>
  );
}